import { Card, CardContent, CardHeader, CardTitle } from '../ui/card'

interface GlossaryTerm {
	term: string
	definition: string
}

export default function GlossaryTerms(props: { terms: GlossaryTerm[] }) {
	const { terms } = props

	return (
		<section className="mb-16">
			<hr className="mt-8" />
			<div className="prose my-8">
				<h2 id="glosario">Glosario</h2>
			</div>
			<div className="grid grid-cols-1 gap-4">
				{terms.map((item, i) => (
					<Card key={i} className="my--4 border-amber-200 bg-amber-100 py-2">
						<CardHeader className="py-0">
							<CardTitle className="text-lg font-bold text-amber-800">
								{item.term}
							</CardTitle>
						</CardHeader>
						<CardContent className="text-amber-950">
							{item.definition}
						</CardContent>
					</Card>
				))}
			</div>
		</section>
	)
}
